<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h1 class="title-pages check-text-center">
            CHECAGEM DE MEDICAMENTOS
          </h1>
        </div>
        <div class="col-md-4" v-if="!resident_id">
          <v-select-default
            item-text="text"
            item-value="value"
            :items="[
              { value: 'ALL', text: 'TODOS' },
              { value: 'ATIVO', text: 'ATIVO' },
              { value: 'INATIVO', text: 'INATIVO' },
            ]"
            label="PROPRIETÁRIO"
            v-model="status"
            @change="getResidents"
          />
        </div>
        <div class="col-md-8" v-if="!resident_id">
          <v-select-default
            item-text="name"
            item-value="id"
            :items="residents"
            label="PROPRIETÁRIO"
            v-model="resident_id"
            @change="handleResident"
          />
        </div>
      </div>
      <div v-if="resident_id" class="p-2">
        <div class="p-2 border">
          <v-btn class="btn-return" v-on:click="handleBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> SELECIONAR OUTRO RESIDENTE
          </v-btn>
          <div v-if="resident" class="mt-2 d-flex align-items-center">
            <img
              class="photo-url mr-2"
              :src="
                permission('read', 'resident_photo') && resident.photo_url
                  ? resident.photo_url
                  : require('../assets/user.png')
              "
            />
            <div>
              <p class="m-0">Residente: <strong>{{resident.name}}</strong></p>
              <p class="m-0">Idade: <strong>{{ getAge(resident.date_of_birth) }} ANOS</strong></p>
            </div>
          </div>
        </div>
      </div>
      <Check v-if="resident_id" :componente="true" />
      <ErrorsMessages :errors="errors" />
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import VSelectDefault from "../templates/Components/VSelectDefault";

import Check from "../views/Check";

import api from "../services/api";

import routes from "../routes";

import permission from "../lib/permission";

import { getAge } from "../lib/getAgeByDate";


export default {
  name: "Annotations",

  components: {
    NavBar,
    ErrorsMessages,
    AuthBySessionExpired,
    VSelectDefault,
    Check
  },

  data() {
    return {
      status: "ATIVO",
      raw_residents: [],
      resident_id: "",
      resident: null,
      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  computed: {
    residents() {
      return [{ id: "", name: "SELECIONE..." }, ...this.raw_residents];
    },
  },

  methods: {
    permission,
    getAge,

    handleBack(){
      this.resident_id = "";
      routes.push({
        name: "checks",
        params: { id: "" },
      });
    },

    handleResident(){
      let { resident_id, raw_residents } = this;

      if(resident_id){
        this.resident = raw_residents.find(raw_resident => raw_resident.id == resident_id);
        routes.push({
          name: "checks",
          params: { id: resident_id },
        });
      }
    },

    async retrieve() {
      await this.getResidents();

      const { id } = routes.history.current.params;

      this.resident_id = id;
    },

    async getResidents() {
      try {
        let { status } = this;
        let params = { status_resident: status };
        const response = await api.get("/rest-home/residents", { params });
        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.raw_residents = residents;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
